import React from "react";
import AdminNavbar from "./AdminNavbar";
import { AdminNavbarAppearanceProvider } from "./AdminNavbarAppearanceContext";
import { theme2NavbarAppearance } from "./adminNavbarTheme2Appearance";

const THEME2_NAVBAR_STYLE_ID = "admin-navbar-shell-theme-2-surface-style";

/**
 * Koyu tema: derlenmiş CSS eskiyse `.navbar.navbar-transparent` şeffaflığı baskın kalır.
 * `document.head` sonuna yazılan kural + yüksek özgüllük (#222a42 = tema $black).
 */
const THEME2_DARK_NAVBAR_SURFACE_CSS = `
body:not(.white-content) .navbar.admin-navbar-shell-theme-2.navbar-transparent {
  background:#2F3742 !important;
  background-color:#2F3742 !important;
}
@media (max-width: 991.98px) {
  body:not(.white-content) .navbar.admin-navbar-shell-theme-2:has(.navbar-collapse.show),
  body:not(.white-content) .navbar.admin-navbar-shell-theme-2:has(.navbar-collapse.collapsing),
  body:not(.white-content) .navbar.admin-navbar-shell-theme-2 .navbar-collapse.show,
  body:not(.white-content) .navbar.admin-navbar-shell-theme-2 .navbar-collapse.collapsing,
  body:not(.white-content) .navbar.admin-navbar-shell-theme-2:has(.navbar-collapse.show) > .container-fluid,
  body:not(.white-content) .navbar.admin-navbar-shell-theme-2:has(.navbar-collapse.collapsing) > .container-fluid {
    background:#2F3742 !important;
    background-color:#2F3742 !important;
  }
}
`;

/**
 * Tema 2 üst bar — appearance context + koyu yüzey (runtime style yedeği).
 */
const AdminNavbarTheme2 = (props) => {
  React.useLayoutEffect(() => {
    let el = document.getElementById(THEME2_NAVBAR_STYLE_ID);
    if (!el) {
      el = document.createElement("style");
      el.id = THEME2_NAVBAR_STYLE_ID;
      document.head.appendChild(el);
    }
    el.textContent = THEME2_DARK_NAVBAR_SURFACE_CSS;
  }, []);

  return (
    <AdminNavbarAppearanceProvider value={theme2NavbarAppearance}>
      <AdminNavbar {...props} />
    </AdminNavbarAppearanceProvider>
  );
};

export default AdminNavbarTheme2;
